import classNames from 'helpers/class-names'
import { FC, ReactElement } from 'react'
import { Switch } from '@headlessui/react'

type Toggle = {
  options: [ReactElement | string, ReactElement | string]
  isRight: boolean
  setIsRight: (value: boolean) => void
  readonly?: boolean
  className?: string
  optionClass?: string
  switchClass?: string
  toggleClass?: string
  variant?: 'compact' | 'normal' | 'large'
}

export const Toggle: FC<Toggle> = ({
  options,
  isRight,
  setIsRight,
  readonly = false,
  className = '',
  variant = 'normal',
  optionClass = '',
  switchClass = '',
  toggleClass = '',
}) => {
  return (
    <Switch.Group>
      <div
        className={classNames(
          'flex flex-row items-center space-x-3',
          className,
        )}>
        <Switch
          disabled={readonly}
          checked={isRight}
          onChange={setIsRight}
          className={classNames(
            {
              'cursor-not-allowed opacity-60': readonly,
            },
            'relative inline-flex shrink-0 items-center bg-gray-100 outline-none transition-colors',
            'outline-0.5 rounded outline-offset-0 outline-gray-100',
            'focus-visible:rounded focus-visible:ring-2 focus-visible:ring-info/75 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-100',
            {
              'h-4 w-[84px]': variant === 'compact',
              'h-5 w-24': variant === 'normal',
            },
            switchClass,
          )}>
          <span
            className={classNames(
              'absolute left-0 right-0 top-0 z-0 rounded bg-white transition-transform',
              {
                'translate-x-full': isRight,
                'translate-x-0': !isRight,
              },
              {
                'h-4 w-[42px]': variant === 'compact',
                'h-5 w-12': variant === 'normal',
              },
              toggleClass,
            )}
          />
          <div
            className={classNames(
              'z-0 inline-flex w-full items-center justify-between font-bold',
              {
                'text-3xs': variant === 'compact',
                'text-2xs': variant === 'normal',
              },
            )}>
            <span
              className={classNames(
                'flex-1',
                {
                  'text-gray-300': isRight,
                  'text-gray-400': !isRight,
                },
                optionClass,
              )}>
              {options[0]}
            </span>
            <span
              className={classNames(
                'flex-1',
                {
                  'text-gray-400': isRight,
                  'text-gray-300': !isRight,
                },
                optionClass,
              )}>
              {options[1]}
            </span>
          </div>
        </Switch>
      </div>
    </Switch.Group>
  )
}
